<i18n src="./../../i18n/department_page.json"></i18n>

<template>
    <div v-if="loaded">
        <div v-if="exist" class="container-fluid">
            <vue-headful
                    :title="content.title + ' | mToilet'"
                    :description="content.description"
                    :url="pageUrl"/>

            <navigation-bar/>

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('header')" />
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">

                        <div class="container">
                            <div class="content-container p-3 pt-5">
                                <div class="row">
                                    <div class="col">
                                        <h1 class="text-center">{{ $t('department') }} {{content.city}}</h1>
                                        <div class="pt-3" v-html="content.fixedFragment"/>
                                        <h2 class="pt-3 text-center" v-text="$t('contactInfo')" />
                                    </div>
                                </div>
                                <div class="col-12">
                                    <hr class="custom">
                                    <div class="row">
                                        <div class="col-md-12 col-lg-7">
                                            <google-map-loader :clickable="false" :position-x="content.xcoordinate" :position-y="content.ycoordinate"/>
                                        </div>
                                        <div class="col-md-12 col-lg-5">
                                            <h3 v-text="$t('address.title')" />
                                            <p><strong>{{ $t('address.department') }} {{content.city}}</strong></p>
                                            <p v-if="content.addressNextLine" v-text="content.addressNextLine"/>
                                            <p v-text="content.address"/>
                                            <p v-text="content.postal + ' ' + content.city"/>
                                            <br>
                                            <p><strong v-text="$t('address.callUs')" /></p>
                                            <p class="phone" v-text="$t('address.phone', { phone: contactPhone })" />
                                            <p class="email" v-html="$t('address.email', { email: contactEmail })" />
                                            <br>
                                            <h3 v-text="$t('address.workHours')" />
                                            <p v-text="content.open"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5 pt-5">
                                    <div class="col description" v-html="content.summary"/>
                                </div>
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else id="404-page">
            <page-not-found/>
        </div>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import GoogleMapLoader from "@/components/commons/GoogleMapLoader";
    import axios from "axios";
    import {Const} from "@/main";
    import PageNotFound from "@/components/commons/PageNotFound";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "DepartmentPage",
        components: {PageNotFound, GoogleMapLoader, MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                contactPhone: Const.CONTACT_PHONE,
                contactEmail: Const.CONTACT_EMAIL,
                content: {},
                exist: false,
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted () {
            axios.get(`${Const.API_HOST}/${this.locale}/content/department/page`, {
                    params: {
                        "url": '/' + this.$route.params.department
                    }
                })
                .then(function (response) {
                    return {
                        status: response.status,
                        body: response.data
                    };
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(resp => {
                this.exist = (resp.status === 200)
                this.content = resp.body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    p {
        padding-left: 15pt;
        margin-bottom: 0.5rem;
    }

    /deep/.description img {
        max-height: 400px;
        max-width: 400px;
        margin: 20px;
    }

    hr.custom {
        width: 250px;
        height: 2px;
        border: 0;
        margin: 20px auto;
    }

    hr.custom {
        background: #295d92;
    }
</style>